import { Container } from '@almbrand/container';
import { Grid, GridCell } from '@almbrand/grid';
import { HeaderComponent, MultiplePageTemplate, QuickBasket } from 'components';
import { NotificationBannerComponent } from 'components/2-molecules';
import { IsPackageComponentContext } from 'context/IsPackageComponentContext';
import { PageContext } from 'context/PageContext';
import { useCustomerModal, useDataLoadEvents, useFetchCustomer, useFormSubmit, useModal, useTracking } from 'hooks';
import { memo, useContext, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectBasketItems } from 'store/slices/basketSlice';
import { loadStaticFieldsToForm } from 'store/slices/calculatorFormSlice';
import { setPlaceholderDefinitions } from 'store/slices/placeholderSlice';
import { submitHiddenFieldsToForm } from '../../../services/HiddenFieldService';
import { loadDefaultsToForm } from '../../../services/PageService';
import styles from './ProductCalculatorPage.module.scss';

export const ProductCalculatorPage: React.FC<PageModel> = memo(() => {
	const pageContext = useContext(PageContext);
	const { headerContent, notificationBannerContent, pageModel, metaArea, theme } = pageContext ?? {};
	const [modalCssStyle, setModalCssStyle] = useState<React.CSSProperties>();
	const { onSubmit } = useFormSubmit();
	const { isVisible } = useContext(IsPackageComponentContext);

	const dispatch = useAppDispatch();
	if (pageModel?.hiddenFields) {
		submitHiddenFieldsToForm(pageModel.hiddenFields);
	}
	const { displayModal } = useModal();
	const count = useAppSelector(selectBasketItems).length;
	useTracking();

	useEffect(() => {
		dispatch(setPlaceholderDefinitions(metaArea));
		dispatch(loadStaticFieldsToForm(metaArea));
		loadDefaultsToForm(metaArea, onSubmit);
	}, []);

	useFetchCustomer();
	useCustomerModal();
	useDataLoadEvents();

	return (
		<>
			<div
				className={
					isVisible
						? styles.ProductCalculatorPage__HeaderComponent__packages
						: styles.ProductCalculatorPage__HeaderComponent
				}
			>
				<Container
					desktopWidth='1600'
					tabletWidth='1280'
					mobileWidth='744'
				>
					<Grid container={theme === 'Privatsikring-theme'}>
						<GridCell>
							<HeaderComponent
								{...headerContent}
								isPackagesPage={isVisible}
								basketIcon={{
									onBasketClick: () => {
										const style = displayModal({
											title: 'Din foreløbige kurv',
											content: <QuickBasket themeName={theme} />,
											subtitle: '',
											padding: { left: 0, right: 0 },
											cssStyle: {
												'--modal-background': 'var(--color-secondary-6)',
												'--modal-close-button-background': 'var(--color-primary-4)',
											} as React.CSSProperties,
										});
										setModalCssStyle(style);
									},
									count: count,
									themeName: theme,
								}}
							/>
							{notificationBannerContent && (
								<NotificationBannerComponent {...notificationBannerContent} />
							)}
						</GridCell>
					</Grid>
				</Container>
			</div>
			<Container
				desktopWidth={isVisible ? 'fullWidth' : '1600'}
				tabletWidth='fullWidth'
				mobileWidth={isVisible ? 'fullWidth' : '360'}
				noPadding
			>
				{/* <Container
					desktopWidth='2500'
					tabletWidth='1600'
					mobileWidth='fullWidth'
				>
					<Grid
						container
						nogutter
					>
						<GridCell desktopWidth='9col'> */}
				<MultiplePageTemplate pageModel={pageModel} />
				{/* </GridCell>
					</Grid>
				</Container> */}
			</Container>
			{/* {!isVisible && (
				<Container mobileWidth='fullWidth'>
					<div
						style={{
							height: 128,
							borderTopLeftRadius: 32,
							borderTopRightRadius: 32,
							background: '#FFF',
							display: 'flex',
							justifyContent: 'center',
							padding: '32px 40px 40px 40px',
							position: 'relative',
						}}
					>
						<Headline
							title='NAVIGATION'
							size='default'
							variant='h2'
						/>
					</div>
				</Container>
			)} */}
		</>
	);
});

ProductCalculatorPage.displayName = 'ProductCalculatorPage';
